// extracted by mini-css-extract-plugin
module.exports = {"paginationButtonLayout":"ShowMoreButton-ShowMoreButton-paginationButtonLayout-fdf2bedf","paginationButton":"ShowMoreButton-ShowMoreButton-paginationButton-a1986f4c"};